import React from 'react';
import './image.css'; // Import the CSS file for styling

const ResponsiveImage = () => {
  return (
    <div className="responsive-image-container">
      <img
        src="/warranty-images/bewellstyle.png"
        alt="Image Bewell"
        className="responsive-image"
      />
    </div>
  );
};

export default ResponsiveImage;
